import { isPublicButton } from 'shared/utils'
import { ArticleButton as ArticleButtonType } from 'site/Renderer/components/ArticleContainer/ArticleContainer.types'

function isValidArticleButton(button: unknown): button is ArticleButtonType {
  if (!button || typeof button !== 'object') return false

  const { label, href } = button as { label: string; href: string }

  if (typeof label !== 'string' || !label.trim()) return false

  if (isPublicButton(button) || ('href' in button && href && !!href.trim())) {
    return true
  }

  return false
}

export default isValidArticleButton
